"use client";

import type { ComponentProps } from "react";
import { useFormStatus } from "react-dom";
import { SheetButton } from "@/components/SheetControl";

/**
 * A form's submit as the sheet's parallelogram control, busy on itself while
 * the form's Server Action runs ("Async actions & progress" in
 * ~/Developer/DESIGN.md). The sign-in and sign-out buttons all hand off to
 * Google or end a session, which takes a visible second or two; a button that
 * looks unchanged for that long reads as a button that did nothing, and gets
 * pressed again.
 *
 * `useFormStatus` reads the NEAREST ENCLOSING <form>, so this has to be a
 * child of the form, never beside it — which is why it is its own component.
 * Without JavaScript the form still posts; only the pending label is lost.
 */
export function PendingSheetSubmit({
  label,
  pendingLabel,
  ...rest
}: Omit<ComponentProps<typeof SheetButton>, "type" | "disabled" | "label"> & { label: string; pendingLabel: string }) {
  const { pending } = useFormStatus();
  return <SheetButton {...rest} type="submit" disabled={pending} aria-busy={pending} label={pending ? pendingLabel : label} />;
}
